module.exports = __webpack_public_path__ + "static/img/brees-2010-slide-1.db5a2d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2010-slide-1.jpg
// module id = WRdV
// module chunks = 1